import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export default function SoftwareSectionTextItemV3({
  title,
  paragraph,
  isSelected,
  borderTransitionDuration
}) {
  const shouldTransition = isSelected && borderTransitionDuration;

  const transition = [
    isSelected && 'opacity .3s ease',
    shouldTransition && `transform ${borderTransitionDuration}ms linear`
  ]
    .filter(Boolean)
    .join(', ');

  return (
    <div className="BreederJoinSoftwareSectionTextItem pl6-lg relative">
      <span
        style={{ transition }}
        className={classnames(
          `
          BreederJoinSoftwareSectionTextItem__border
          absolute left-0 bottom-0 pl1-lg bg-purple h-100
        `,
          {
            'o-0': !isSelected,
            'BreederJoinSoftwareSectionTextItem__border--transitioning':
              shouldTransition
          }
        )}
      />
      <p
        className={classnames('subheader mb2', { purple: isSelected })}
        /* eslint-disable-next-line react/no-danger */
        dangerouslySetInnerHTML={{ __html: title }}
      />
      <p
        className="fw-normal"
        /* eslint-disable-next-line react/no-danger */
        dangerouslySetInnerHTML={{ __html: paragraph }}
      />
    </div>
  );
}

SoftwareSectionTextItemV3.propTypes = {
  title: PropTypes.string.isRequired,
  paragraph: PropTypes.string.isRequired,
  isSelected: PropTypes.bool,
  borderTransitionDuration: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.bool
  ])
};

SoftwareSectionTextItemV3.defaultProps = {
  isSelected: false,
  borderTransitionDuration: false
};
